import { render, staticRenderFns } from "./bikeFault.vue?vue&type=template&id=0cf914d2&scoped=true&"
import script from "./bikeFault.vue?vue&type=script&lang=js&"
export * from "./bikeFault.vue?vue&type=script&lang=js&"
import style0 from "./bikeFault.vue?vue&type=style&index=0&id=0cf914d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf914d2",
  null
  
)

export default component.exports